export enum TypeOfLoco {
  Miscellaneous = '0',
  Electric = '1',
  Diesel = '2',
  HighSpeedElectricMultipleUnit = '3',
  ElectricMultipleUnit = '4',
  DieselMultipleUnit = '5',
  SpecializedTrailer = '6',
  ElectricShuntingEngine = '7',
  DieselShuntingEngine = '8',
}
